/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import isObjectLike from 'lodash/isObjectLike';
import isString from 'lodash/isString';
import Numeric from '../numeric/numeric';

/**
 * @import { MediumAttrs } from '../medium/medium-attrs'
 * @import { AnalyticsGroupVxAttrs } from './analytics-group-attrs'
 */

/**
 * Atributy agregovaných analytických dat pro jedno médium.
 * @typedef AnalyticsCounterAttrs
 * @property {AnalyticsGroupVxAttrs['id']} analyticsGroupId Identifikátor analytické skupiny, do které data patří.
 * @property {string} id Identifikátor.
 * @property {MediumAttrs['id']} mediumId Identifikátor média spojeného s analýzou.
 * @property {MediumAttrs['name']} name Název média.
 * @property {number} played Počet přehrání média (celé kladné číslo).
 * @property {string} type Typ média.
 */

/**
 * Zjistí, zda je hodnota instancí {@link AnalyticsCounterAttrs} a obsahuje všechny povinné atributy.
 * @param {any} value
 * @returns {value is AnalyticsCounterAttrs}
 */
export function isAnalyticsCounterAttrs(value) {
  return (
    isObjectLike(value) &&
    isString(value.id) &&
    isString(value.analyticsGroupId) &&
    isString(value.mediumId) &&
    isString(value.name) &&
    Numeric.isIndex(value.played) &&
    value.played > 0 &&
    isString(value.type)
  );
}
